import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));


// Service worker disabled - not generated by react-scripts 5.x by default
// If you want your app to work offline and load faster, you would need to
// configure a custom service worker or use a PWA framework.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
